import { render, staticRenderFns } from "./SignatureDialog.vue?vue&type=template&id=02514161"
import script from "./SignatureDialog.vue?vue&type=script&lang=js"
export * from "./SignatureDialog.vue?vue&type=script&lang=js"
import style0 from "./SignatureDialog.vue?vue&type=style&index=0&id=02514161&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports